import React, { HTMLAttributes, useEffect } from 'react';
import styles from './styles.module.scss';

// assets

// services

// props

// components
import { ActionButton, IDropdownOption, Link, PrimaryButton, Stack, TagPicker } from '@fluentui/react';
import { IVendorResourceShortProps } from '../../../../props/data/vendors';
import Label from '../../../typography/label';
import Text from '../../../typography/text';
import VendorsService from '../../../../services/data/vendors';
import VendorForm from '../../../operationals/vendors/general/form';
import PermissionsService from '../../../../services/permissions';
import { useStore } from '../../../../stores/root';

type FormFooterProps = HTMLAttributes<string> & {
    hasNextButton?: boolean;
    hasPrevButton?: boolean;
    hasSubmitButton?: boolean;
    position: 'fixed' | 'relative';
    variant?: 'plain' | 'card';
    onNext?(): void;
    onPrev?(): void;
    onSubmit?(): void;
}

export type IFormPage = {
    key: string;
    title: string;
    description?: string;
}

const FormFooter: React.FC<FormFooterProps> = (props: FormFooterProps) => {
    const { user } = useStore();
    const [pages, setPages] = React.useState<IFormPage[]>([]);
    const [selectedKey, setSelectedKey] = React.useState<string | undefined>();

    return <Stack verticalAlign={'center'} className={`${styles.container} ${styles[props.variant || 'plain']} ${styles[props.position]}`} horizontal tokens={{childrenGap: 20}} horizontalAlign={'space-between'} style={props.style}>
        <Stack horizontal tokens={{childrenGap: 20}}>
            {props.hasPrevButton && props.onPrev ? <ActionButton iconProps={{iconName: "ChevronLeft"}} text={"Prev"} onClick={props.onPrev} /> : null}
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            {props.hasNextButton && props.onNext ? <ActionButton menuIconProps={{ iconName: "ChevronRight" }} text={"Next"} onClick={props.onNext} /> : null}
            {props.hasSubmitButton && props.onSubmit ? <PrimaryButton text={"Submit"} onClick={props.onSubmit} /> : null}
        </Stack>
    </Stack>;
};

export default FormFooter;
